export default __webpack_public_path__ + "static/media/Copy.6a9de924.svg";